import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, shadow, fontSize } = theme.tokens;
  return {
    card: {
      padding: 24,
      borderRadius: radius.card,
      boxShadow: shadow.hairline,
      backgroundColor: color.bg,
      display: "flex",
      flexDirection: "column",
      gap: 12,
      [theme.media.phone]: { padding: 16 }
    },
    head: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: 12
    },
    headText: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      minWidth: 0
    },
    orderTitle: {
      margin: 0,
      fontSize: fontSize.title,
      fontWeight: 800,
      color: color.ink
    },
    when: {
      fontSize: fontSize.small,
      color: color.muted
    },
    meta: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      gap: "4px 16px",
      fontSize: fontSize.body,
      color: color.text2
    },
    total: {
      color: color.ink,
      fontWeight: 800
    },
    payment: {
      fontSize: fontSize.small,
      color: color.muted
    },
    statusLine: {
      margin: 0,
      fontSize: fontSize.ui,
      color: color.muted
    },
    actions: {
      display: "flex",
      flexWrap: "wrap",
      gap: 8,
      paddingTop: 4
    },
    details: {
      marginTop: 4,
      paddingTop: 4,
      boxShadow: `inset 0 1px 0 ${color.line}`
    },
    summary: {
      marginTop: 8,
      paddingTop: 12,
      boxShadow: `inset 0 1px 0 ${color.line}`
    },
    payfastPaymentWrap: {
      textAlign: "center",
      width: "100%"
    }
  };
});

export default withCustomStyles;
